import { ChangeEvent, SyntheticEvent } from "react";
import { Divider, Grid, Typography } from "@mui/material";
import AutoCompleteGrouped from "components/input/autoCompleteGrouped";
import TextFieldInput from "components/input/textField";
import { ActivityFormConfig } from "../utils/activityFormConfig";

type ActivityBasicInformationFieldsProps = {
  config: ActivityFormConfig;
  translate: (key: string) => string;
  title: string;
  description: string;
  ownerName: string;
  activityTypes: any[];
  selectedActivityType: any[];
  titleError: boolean;
  onTitleChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onDescriptionChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onOwnerNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onActivityTypeChange: (event: SyntheticEvent<Element, Event>, value: any) => void;
  elements?: Array<"title" | "description" | "type">;
  showDescriptionHeading?: boolean;
};

const ActivityBasicInformationFields = ({
  config,
  translate,
  title,
  description,
  ownerName,
  activityTypes,
  selectedActivityType,
  titleError,
  onTitleChange,
  onDescriptionChange,
  onOwnerNameChange,
  onActivityTypeChange,
  elements,
  showDescriptionHeading = false,
}: ActivityBasicInformationFieldsProps) => (
  <>
    {(!elements || elements.includes("title")) && config.isVisible("title") && (
      <Grid item xs={12}>
        <TextFieldInput
          title={translate("title")}
          value={title}
          showLabel={true}
          fullWidth={true}
          handleChange={onTitleChange}
          required={true}
          disabled={config.isDisabled("title")}
          error={titleError}
        />
      </Grid>
    )}

    {(!elements || elements.includes("description")) && config.isVisible("description") && (
      <>
        {showDescriptionHeading && (
          <Grid item xs={12}>
            <Typography variant="h5" sx={{ mb: -1 }}>
              {translate("description")}
            </Typography>
          </Grid>
        )}
        <Grid item xs={12}>
          <TextFieldInput
            title={translate("description")}
            value={description}
            showLabel={true}
            fullWidth={true}
            disabled={config.isDisabled("description")}
            handleChange={onDescriptionChange}
            multiline={true}
            minRows={2}
            maxRows={5}
            // The legacy position is compact because Description normally follows
            // Title. A configured section heading needs the normal grid spacing.
            sx={{ mt: showDescriptionHeading ? 0 : -1 }}
          />
        </Grid>
      </>
    )}

    {/* {config.isVisible("owner") && (
      <>
        <Grid item xs={12}>
          <Divider />
        </Grid>

        <Grid item xs={12}>
          <TextFieldInput
            title={translate("activity-information-owner")}
            placeholder={translate("activity-information-owner-placeholder")}
            value={ownerName}
            showLabel={true}
            fullWidth={true}
            handleChange={onOwnerNameChange}
            disabled={config.isDisabled("owner")}
            required={false}
          />
        </Grid>
      </>
    )} */}

    {(!elements || elements.includes("type")) && config.isVisible("type") && (
      <>
        <Grid item xs={12}>
          <Divider />
        </Grid>

        <Grid item xs={12}>
          <AutoCompleteGrouped
            title={translate("activity-type")}
            label={translate("activity-type")}
            showTitle={false}
            showLabel={true}
            data={activityTypes}
            groupByField="groupName"
            renderOptionField="label"
            renderTagField="label"
            noOptionsText={translate("no-results")}
            changeHandler={onActivityTypeChange}
            value={selectedActivityType}
            multiple={true}
            disabled={config.isDisabled("type")}
          />
        </Grid>
      </>
    )}
  </>
);

export default ActivityBasicInformationFields;
